export default __webpack_public_path__ + "static/media/header.d80cb689.jpg";